import { MutationTree } from "vuex/types";
import { FileUploadState } from "./types";
import Vue from "vue";

/**
 * Mutations for the File Storage module.
 * Handles synchronous state updates for storage configuration.
 */
const mutations: MutationTree<FileUploadState> = {
  /**
   * Sets the storage backend type.
   *
   * @param {FileUploadState} state - Module state
   * @param {string} storageType - Storage type ('azure' or 'ceph')
   */
  SET_STORAGE_TYPE: (state, storageType: string) => {
    Vue.set(state, "storageType", storageType);
  },

  /**
   * Sets the maximum file upload size (in MB).
   *
   * @param {FileUploadState} state - Module state
   * @param {number} fileUploadSizeLimit - Max upload size in MB
   */
  SET_FILE_UPLOAD_SIZE_LIMIT: (state, fileUploadSizeLimit: number) => {
    Vue.set(state, "fileUploadSizeLimit", fileUploadSizeLimit);
  },

  /**
   * Sets the deployment upload-size ceiling (env-derived, without the per-bot layer).
   *
   * @param {FileUploadState} state - Module state
   * @param {number} fileUploadSizeCeiling - Ceiling in MB
   */
  SET_FILE_UPLOAD_SIZE_CEILING: (state, fileUploadSizeCeiling: number) => {
    Vue.set(state, "fileUploadSizeCeiling", fileUploadSizeCeiling);
  },

  /**
   * Sets the server-provided allowed file extensions.
   *
   * @param {FileUploadState} state - Module state
   * @param {string[]} extensions - Array of allowed extensions (e.g. [".pdf", ".docx"])
   */
  SET_FILE_UPLOAD_ALLOWED_EXTENSIONS: (state, extensions: string[]) => {
    Vue.set(state, "fileUploadAllowedExtensions", extensions);
  },

  /**
   * Sets the server-provided allowed MIME types.
   *
   * @param {FileUploadState} state - Module state
   * @param {string[]} mimeTypes - Array of allowed MIME types (e.g. ["application/pdf"])
   */
  SET_FILE_UPLOAD_ALLOWED_MIME_TYPES: (state, mimeTypes: string[]) => {
    Vue.set(state, "fileUploadAllowedMimeTypes", mimeTypes);
  },
};

export default mutations;
